import { LOCATION_CHANGE } from 'react-router-redux';

export default function shippingForm(state = {}, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        error: undefined,
      };
    default:
      return state;
  }
}